import React from "react";
import HeroSection from "./components/heroSection/HeroSection";
import AboutUsSection from "./components/aboutSection/AboutUsSection";
import ServiceSection from "./components/serviceSection/ServiceSection";
import NumbersSection from "./components/numbersSection/NumbersSection";
import ReviewsSection from "./components/reviewsSection/ReviewsSection";
import NewsSection from "./components/newsSection/NewsSection";

function HomePage() {
  
  return (
    <>
      <HeroSection/>
      <AboutUsSection/>
      <NewsSection/>
      <ServiceSection/>
      <NumbersSection/>
      <ReviewsSection/>
    </>
  );
}

export default HomePage;
